import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { InvoicesServices } from "../../invoices/services";
import { ConfigurationServices } from '../../configuration/services';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { Color } from 'ng2-charts';
import { SalesServices } from '../services';
import { ConfigurationTicketsListPage } from '../../configuration/configuration-tickets/configuration-tickets-list/configuration-tickets-list';
import { CustomersCreateDataPage } from '../../customers/customers-create/customers-create-data/customers-create-data';
import { CustomersListPage } from '../../customers/customers-list/customers-list';
import { ConfigurationTicketsPage } from '../../configuration/configuration-tickets/configuration-tickets';
import { InvoicesListPage } from '../../invoices/invoices-list/invoices-list';
import { InvoicesViewPage } from '../../invoices/invoices-view/invoices-view';
import { TranslateService } from '@ngx-translate/core';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ConfigurationCloseCashViewPage } from '../../configuration/configuration-close-cash/configuration-close-cash-view/configuration-close-cash-view';
import { ConfigurationTicketsRatingsListPage } from '../../configuration/configuration-tickets/configuration-tickets-ratings-list/configuration-tickets-ratings-list';
import { AnalyticsPage } from '../../analytics/analytics';
import { TutorialSalesPage } from '../../help/tutorials/tutorial-sales/tutorial-sales';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { ImportSalesPage } from '../../components/import-excel/import-sales/import-sales';

/**
 * Generated class for the SalesListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-sales-list',
  templateUrl: 'sales-list.html',
})
export class SalesListPage {

  date_first: any;
  date_last: any;
  uid_cash: string = 'all';
  cash_uid: string = 'all';
  loader_totals: boolean = true;

  top_elements = [];
  loader_elements: boolean = true;
  //vars
  lastTicketsPayedList: any = [];
  aleatori7customersList: any = [];
  last7Invoices: any = [];
  total_tickets_sales_today: any = 0;
  salesToday: any = 0;
  total_tips: any = 0;
  total_elements_sold_today: any = 0;
  total_fact = 0;
  media_fact = 0;
  elementsSoldToday: any;
  elementMostSold: any = '';
  checkElementsSold: boolean = false;


  loader = true;
  positive = 0;
  negative = 0;
  neutral = 0;
  ratings_positive = 0;
  ratings_negative = 0;
  ratings_neutral = 0;
  total_ratings = 0;

  //datatable
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };
  activeTab: string = 'lastTickets';

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public invoicesServices: InvoicesServices,
    public configurationServices: ConfigurationServices,
    public http: HttpClient,
    public salesServices: SalesServices,
    public translate: TranslateService) {

    this.globals.GAtrackView('Sales', 'Sales - List', this.globals.restaurant.email, 'View', 'List sales', 'Sales', '');

    //Tutorial Sales
    if (this.globals.restaurant.license == 'free') {
      this.navCtrl.push(TutorialSalesPage);
    }

    if (this.globals.checkLimitsByLicense('sales', 'invoices')) {
      this.last7InvoiceslList();
    }
    if (this.globals.checkLimitsByLicense('sales', 'invoices_to_pay')) {
      this.invoicesServices.getInvoicesPending(this.globals.restaurant_uid);
    }
    if (this.globals.checkLimitsByLicense('sales', 'customers')) {
      this.getAleatori7Customers();
    }
    if (this.globals.checkLimitsByLicense('sales', 'analytics')) {
      this.analyticsGetSalesWeek();
      this.analyticsGetsalesToday();
      this.analyticsGetTotalSalesArticlesToday();
      this.analyticsGetElementsSoldInWeek();
      this.getTotals();
      this.getAnalyticsData();
    }
    if (this.globals.checkLimitsByLicense('sales', 'ratings')) {
      this.getRatings();
    } else {
      this.loader = false;
    }
  }

  ionViewWillEnter() {
    if (this.globals.checkLimitsByLicense('sales', 'tickets')) {
      this.last7TicketsPayedList();
    }
  }

  // #region CHARTS

  public chartSalesWeekLabels: string[];
  public chartSalesWeekData: any;
  public chartSalesWeekType: string = 'line';
  public chartSalesWeekOptions: any = {
    legend: {
      display: false,
      position: 'top',
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [{
        gridLines: {
          display: false
        }

      }],
      yAxes: [{
        gridLines: {
          display: false
        }
      }]
    },

  };
  public lineChartColors: Color[] = [
    {
      backgroundColor: 'transparent',
      borderColor: 'orange',
      pointBackgroundColor: 'orange',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  public doughnutChartLabels: string[];
  public doughnutChartData: any;
  public doughnutChartType: string = 'doughnut';
  public doughnutChartOptions: any = {
    maintainAspectRatio: false,
    legend: {
      position: 'right'
    }
  };

  // #region FUNCIONES A NODE/FIRESTORE

  public chartSalesCheck: boolean = false;
  async analyticsGetSalesWeek() {
    var first_day = moment().subtract(7, 'days').format("YYYY-MM-DD");
    var last_day = moment().format("YYYY-MM-DD");
    this.http.post(this.globals.analytics_path + 'sales-details/' + this.globals.restaurant_uid
      + '/' + first_day + '/' + last_day
      , {}, {})
      .subscribe(res => {
        this.chartSalesWeekData = res[0]['data']; //total's
        this.chartSalesWeekLabels = res[0]['labels'];//Dates
        this.total_fact = res[0]['total'];
        this.media_fact = res[0]['average'];
        this.chartSalesCheck = true;//boolean check
      });
  }

  async analyticsGetElementsSoldInWeek() {
    var date = moment().subtract(7, 'days').format("YYYY-MM-DD");
    this.http.post(this.globals.analytics_path + 'elements-sold-week/' + this.globals.restaurant_uid
      + '/' + date
      , {}, {})
      .subscribe(res => {
        this.doughnutChartLabels = res['labels']; //names
        this.doughnutChartData = res['data'];//total's
        this.elementsSoldToday = res['elements']; //all elementes
        if (Object.keys(res['elements']).length > 0) {
          this.checkElementsSold = true;
          this.elementMostSold = this.elementsSoldToday[0][0]; //first element of array
        }
      });
  }

  async analyticsGetsalesToday() {
    //
    var date_first = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
    var date_last = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
    //
    const body = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('datetime_init', date_first)
      .set('datetime_final', date_last);

    await this.http.post(this.globals.analytics_path + 'sales-day', body).subscribe(async data => {
      this.salesToday = data['total_amount'];
      this.total_tips = data['total_tips'];
      this.total_tickets_sales_today = data['total_tickets'];
    },
      err => {
      }
    );
  }

  async analyticsGetTotalSalesArticlesToday() {

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'));
    this.http.post(this.globals.analytics_path + 'analytics/elements_total_sold', params, {})
      .subscribe(async response => {
        this.total_elements_sold_today = response['total_elements_sold'];
      });
  }

  //llistats
  async last7TicketsPayedList() {
    await this.http.post(this.globals.analytics_path + 'tickets/get_last_7_tickets_payed', {
      uid_restaurant: this.globals.restaurant_uid,
    }, {}).subscribe(async data => {
      this.lastTicketsPayedList = data['last_7_tickets_payed'];
    },
      err => {
      });
  }

  async getAleatori7Customers() {
    this.aleatori7customersList = await this.salesServices.get7Customers(this.globals.restaurant_uid);
    this.aleatori7customersList.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
  }

  async last7InvoiceslList() {
    this.last7Invoices = await this.salesServices.getLast7InvoicesList(this.globals.restaurant_uid);
  }

  // #region FUNCIONES

  openTicket(event) {
    if (event.type == 'click') {
      this.globals.side_menu_config_active = 'tickets';
      this.navCtrl.push(ConfigurationTicketsListPage, {
        state: 'closed',
        ticket: event.row,
      });
    }
  }

  openCustomer(event) {
    if (event.type == 'click') {
      this.navCtrl.push(CustomersCreateDataPage, {
        update_state: true,
        customer_uid: event.row.UID,
        name: event.row.name,
        business_name: event.row.business_name,
        business_number: event.row.business_number,
        email: event.row.email,
        phone: event.row.phone,
        address: event.row.address,
        note: event.row.note,
      });
    }
  }

  openInvoices(event) {
    if (event.type == 'click') {
      this.navCtrl.push(InvoicesViewPage, {
        'type': 'pay',
        'invoice': event.row,
      });
    }
  }

  openAnalytics() {
    this.globals.side_menu_active = 'informes';
    this.navCtrl.push(AnalyticsPage);
  }

  async getTotals() {
    var date_first = moment().subtract(7, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    var date_last = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    //
    await this.http.post(this.globals.analytics_path + 'biclosecash/get_totals', {
      public_key: this.globals.public_key,
      uid_cash: this.cash_uid,
      datetime_init: new Date(date_first),
      datetime_final: new Date(date_last),
    }, {}).subscribe(async data => {
      this.configurationServices.biclosecash_total = data['total'];
      this.configurationServices.biclosecash_total_notax = data['total_notax'];
      this.configurationServices.biclosecash_total_tax = data['total_tax'];
      this.configurationServices.biclosecash_total_tips = data['total_tips'];
      this.configurationServices.biclosecash_total_with_tips = data['total_with_tips'];
      this.configurationServices.biclosecash_total_taxes = data['total_taxes'];
      this.loader_totals = false;
    },
      err => {
        this.loader_totals = false;
      });
  }

  async getAnalyticsData() {
    var date_first = moment().subtract(7, 'day').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    var date_last = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    //
    await this.http.post(this.globals.analytics_path + 'analytics/elements_top_sold_sales', {
      public_key: this.globals.public_key,
      first_date: new Date(date_first),
      last_date: new Date(date_last),
    }, {}).subscribe(async response => {
      this.top_elements = response['list'];
      this.loader_elements = false;
    });
  }

  openTicketsList() {
    this.navCtrl.push(ConfigurationTicketsPage, {
      headfooter: this.globals.restaurant.tickets,
    });
  }

  openCustomerList() {
    if (this.globals.checkLimitsByLicense('sales', 'customers')) {
      this.navCtrl.push(CustomersListPage);
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  closeCash() {
    this.navCtrl.push(ConfigurationCloseCashViewPage);
  }

  openInvoicesList() {
    this.navCtrl.push(InvoicesListPage);
  }

  openInvoice(event) {
    if (event.type == 'click') {
      this.navCtrl.push(InvoicesViewPage, {
        'type': 'create',
        'invoice': event.row,
      });
    }
  }

  styleIcon(total) {
    let styles = {
      'width': total + '%',
    };
    return styles;
  }

  openRatingsList() {
    this.navCtrl.push(ConfigurationTicketsRatingsListPage);
  }

  async getRatings() {
    await this.http.post(this.globals.analytics_path + 'get_restaurant_ratings', {
      public_key: this.globals.public_key,
    }, {}).subscribe(async data => {
      this.positive = 0;
      this.negative = 0;
      this.neutral = 0;
      for (let rating of this.globals.objectToArray(data)) {
        if (rating.value == 'positive') {
          this.positive++;
        } else if (rating.value == 'negative') {
          this.negative++;
        } else if (rating.value == 'neutral') {
          this.neutral++;
        }
      }

      this.total_ratings = (this.positive + this.negative + this.neutral);
      if (this.positive != 0) { //comprovamos que no sea 0 para que la regla de 3 no de infinito
        this.ratings_positive = this.globals.regla3(this.total_ratings, this.positive);
      } else {
        this.ratings_positive = 0;
      }
      if (this.negative != 0) { //comprovamos que no sea 0 para que la regla de 3 no de infinito
        this.ratings_negative = this.globals.regla3(this.total_ratings, this.negative);
      } else {
        this.ratings_negative = 0;
      }
      if (this.neutral != 0) { //comprovamos que no sea 0 para que la regla de 3 no de infinito
        this.ratings_neutral = this.globals.regla3(this.total_ratings, this.neutral);
      } else {
        this.ratings_neutral = 0;
      }
      this.loader = false;
    }, err => { });
  }

  //
  trFontColor(ticket) {
    if (ticket.refund && ticket.amount < 0) {
      let cssClasses = {
        'text-danger': true,
      };
      return cssClasses;
    }
    return '';
  }

  openImportSales() {
    this.navCtrl.push(ImportSalesPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/sales/sales-list/sales-list.ts